export const splitPathname = (pathname: string) => pathname.replace(/^\//g, '').split('/');
